import CreateNewUser from "./pages/Users/CreateNewUser";
import React, { Children, Suspense, lazy } from "react";

import NotFound from "./pages/NotFound";
import { Route } from "react-router-dom";
import Loader from "./components/Loader/Loder";
import CreateAd from "./pages/Products/CreateAd";
import UpdateAd from "./pages/Products/UpdateAd";
import RealEstateAgency from "./pages/RealEstateAgency/RealEstateAgency";
import RealEstateConsultants from "./pages/RealEstateConsultants/RealEstateConsultants";
import UserEdit from "./pages/Users/UserEdit";
import EditSubscriberWallet from "./pages/EditSubscriberWallet/EditSubscriberWallet";

const Home = React.lazy(() => import("./pages/Home/Home"));
// const Test = React.lazy(()=> import("./pages/Test/Test"))
// import MonitoringPage from "./pages/Monitoring/Monitoring";

const Login = React.lazy(() => import("./pages/Login/Login"));
const MonitoringPage = React.lazy(() => import("./pages/Monitoring/Monitoring"));

// const CreateNewUser = React.lazy(()=> import("./pages/Users/CreateNewUser"))
// import CreateNewUser from "./pages/Users/CreateNewUser";
const UsersList = React.lazy(() => import("./pages/Users/UsersList"));
const AdValidity = React.lazy(() => import("./pages/Products/AdValidity"));

const EditUser = React.lazy(() => import("./pages/Users/EditUser"));
const UserProfile = React.lazy(() => import("./pages/Users/UserProfile"));
const ProfileDetail = React.lazy(() => import("./pages/Users/ProfileDetail"));
const Suspension = React.lazy(() => import("./pages/Users/Suspension"));
const Message = React.lazy(() => import("./pages/Users/Message"));
const Slide = React.lazy(() => import("./pages/Content/Slide/Slide"));
const NewSlide = React.lazy(() => import("./pages/Content/Slide/NewSlide"));
const Rules = React.lazy(() => import("./pages/Content/Rules/RulesManagement"));
const Chat = React.lazy(() => import("./pages/Chat/ChatPage"));
const Category = React.lazy(() =>
    import("./pages/categoryManagement/CategoryManagement")
);

const Modals = React.lazy(() =>
    import("./pages/ModalsManagement/ModalsManagement")
);

const TeammateProfile = React.lazy(() =>
    import("./pages/Users/TeammateProfile")
);
const TeammateEditProfile = React.lazy(() =>
    import("./pages/Users/TeammateEditProfile")
);
const TeammateEdit = React.lazy(() => import("./pages/Users/TeammateEdit"));
const Transactions = React.lazy(() =>
    import("./pages/Transactions/Transactions")
);
const CreateProduct = React.lazy(() =>
    import("./pages/Products/CreateProducts")
);
const Estate = React.lazy(() => import("./pages/Products/Estate"));
const Amlak = React.lazy(() => import("./pages/Products/Amlak"));
const State1 = React.lazy(() => import("./pages/Products/StatesCreate/State1"));
const State2 = React.lazy(() => import("./pages/Products/StatesCreate/State2"));
const State3 = React.lazy(() => import("./pages/Products/StatesCreate/State3"));
const State4 = React.lazy(() => import("./pages/Products/StatesCreate/State4"));
const State5 = React.lazy(() => import("./pages/Products/StatesCreate/State5"));
const State6 = React.lazy(() => import("./pages/Products/StatesCreate/State6"));
const State7 = React.lazy(() => import("./pages/Products/StatesCreate/State7"));
const State8 = React.lazy(() => import("./pages/Products/StatesCreate/State8"));
const State9 = React.lazy(() => import("./pages/Products/StatesCreate/State9"));
const State10 = React.lazy(() =>
    import("./pages/Products/StatesCreate/State10")
);
const State11 = React.lazy(() =>
    import("./pages/Products/StatesCreate/State11")
);
const State12 = React.lazy(() =>
    import("./pages/Products/StatesCreate/State12")
);

const ProductsList = React.lazy(() => import("./pages/Products/ProductsList"));
const PageOne = React.lazy(() => import("./pages/Products/PageOne"));
const PageTwo = React.lazy(() => import("./pages/Products/PageTwo"));
const PageThree = React.lazy(() => import("./pages/Products/PageThree"));
const Reporteds = React.lazy(() => import("./pages/Products/Reporteds"));
const ProductDetails = React.lazy(() =>
    import("./pages/Products/ProductDetails")
);
const Support = React.lazy(() =>
    import("./pages/MessageCenter/Message/Support")
);
const Request = React.lazy(() =>
    import("./pages/MessageCenter/Message/Request")
);
const ConfirmationRequest = React.lazy(() =>
    import("./pages/MessageCenter/Message/ConfirmationRequest")
);
const ConfirmationRequestShop = React.lazy(() =>
    import("./pages/MessageCenter/Message/ConfirmationRequestShop")
);
const MsgList = React.lazy(() =>
    import("./pages/MessageCenter/Message/MsgList")
);
const Report = React.lazy(() => import("./pages/MessageCenter/Message/reports/ReportPage"));
const CityProvinceManagement = React.lazy(() =>
    import("./pages/CityProvinceManagement/CityProvinceManagement")
);
const Automation = React.lazy(() => import("./pages/Automation/Automation"));
const DiscountAndScore = React.lazy(() =>
    import("./pages/DiscountAndScore/DiscountAndScore")
);
const PriceManagement = React.lazy(() =>
    import("./pages/PriceManagement/PriceManagement")
);

// const Manitoring = React.lazy(() => import("./pages/Manitoring/Manitoring"));
const MsgSetting = React.lazy(() =>
    import("./pages/MessageCenter/Message/MsgSetting")
);
const SendGroupMsg = React.lazy(() =>
    import("./pages/MessageCenter/Message/SendGroupMsg")
);
const AutomaticMsg = React.lazy(() =>
    import("./pages/MessageCenter/Message/AutomaticMsg")
);
const Suggest = React.lazy(() =>
    import("./pages/MessageCenter/Message/Suggest")
);


const LawyersMain = React.lazy(() =>
    import("./pages/LawyersMain/UpdateLawyersMain")
);
const LawyersCategory = React.lazy(() =>
    import("./pages/LawyersCategory/LawyersCategory")
);
const CreateLawyersCategory = React.lazy(() =>
    import("./pages/LawyersCategory/CreateLawyersCategory")
);
const EditLawyersCategory = React.lazy(() =>
    import("./pages/LawyersCategory/EditLawyersCategory")
);
const LawyersCategoryFiles = React.lazy(() =>
    import("./pages/LawyersCategoryFile/LawyersCategoryFiles")
);
const CreateLawyersCategoryFile = React.lazy(() =>
    import("./pages/LawyersCategoryFile/CreateLawyersCategoryFile")
);
const EditLawyersCategoryFile = React.lazy(() =>
    import("./pages/LawyersCategoryFile/EditLawyersCategoryFile")
);
const Lawyers = React.lazy(() =>
    import("./pages/Lawyer/Lawyers")
);

const CreateLawyer = React.lazy(() =>
    import("./pages/Lawyer/CreateLawyer")
);

const EditLawyer = React.lazy(() =>
    import("./pages/Lawyer/EditLawyer")
);
const ConsultationDurations = React.lazy(() =>
    import("./pages/ConsultationDuration/ConsultationDurations")
);

const CreateConsultationDuration = React.lazy(() =>
    import("./pages/ConsultationDuration/CreateConsultationDuration")
);

const EditConsultationDuration = React.lazy(() =>
    import("./pages/ConsultationDuration/EditConsultationDuration")
);


const AboutUsManagmant = React.lazy(() =>
    import("./pages/AboutUs/AboutUsManagmant")
);
const TeammateProfileDetails = React.lazy(() =>
    import("./pages/Users/TeammateProfileDetails")
);

const ChangePassword = React.lazy(() =>
    import("./pages/ChangePassword/ChangePassword")
);
const Blogs = React.lazy(() =>
    import("./pages/Blogs/Blogs")
);
const Subscriptions = React.lazy(() =>
    import("./pages/Subscriptions/Subscriptions")
);
const Manufactureres = React.lazy(() =>
    import("./pages/Manufactureres/Manufactureres")
);
const Price = React.lazy(() =>
    import("./pages/PriceManaging/Price")
);

// const Subscriptions = React.lazy(() =>
//   import("./pages/Subscriptions/Subscriptions")
// );
// const Subscriptions = React.lazy(() =>
//   import("./pages/Subscriptions/Subscriptions")
// );
// const Subscriptions = React.lazy(() =>
//   import("./pages/Subscriptions/Subscriptions")
// );

const router = [
    {
        path: "/Subscriptions",
        element: (
            <Suspense fallback={<Loader />}>
                <Subscriptions />
            </Suspense>
        ),
    },
    {
        path: "/priceManaging",
        element: (
            <Suspense fallback={<Loader />}>
                <Price />
            </Suspense>
        ),
    },
    {
        path: "/Manufactureres",
        element: (
            <Suspense fallback={<Loader />}>
                <Manufactureres />
            </Suspense>
        ),
    },
    {
        path: "/RealEstateAgency",
        element: (
            <Suspense fallback={<Loader />}>
                <RealEstateAgency />
            </Suspense>
        ),
    },
    {
        path: "/RealEstateConsultants",
        element: (
            <Suspense fallback={<Loader />}>
                <RealEstateConsultants />
            </Suspense>
        ),
    },
    {
        path: "/Blogs",
        element: (
            <Suspense fallback={<Loader />}>
                <Blogs />
            </Suspense>
        ),
    },
    {
        path: "/ChangePassword",
        element: (
            <Suspense fallback={<Loader />}>
                <ChangePassword />
            </Suspense>
        ),
    },
    {
        path: "/TeammateProfileDetails",
        element: (
            <Suspense fallback={<Loader />}>
                <TeammateProfileDetails />
            </Suspense>
        ),
    },
    {
        path: "/LawyersMain",
        element: (
            <Suspense fallback={<Loader />}>
                <LawyersMain />
            </Suspense>
        ),
    },
    {
        path: "/LawyersCategory",
        element: (
            <Suspense fallback={<Loader />}>
                <LawyersCategory />
            </Suspense>
        ),
    }, {
        path: "/LawyersCategory/Create",
        element: (
            <Suspense fallback={<Loader />}>
                <CreateLawyersCategory />
            </Suspense>
        ),
    },
    {
        path: "/LawyersCategory/Edit/:id",
        element: (
            <Suspense fallback={<Loader />}>
                <EditLawyersCategory />
            </Suspense>
        ),
    },
    {
        path: "/LawyersCategoryFile",
        element: (
            <Suspense fallback={<Loader />}>
                <LawyersCategoryFiles />
            </Suspense>
        ),
    },
    {
        path: "/LawyersCategoryFile/Create",
        element: (
            <Suspense fallback={<Loader />}>
                <CreateLawyersCategoryFile />
            </Suspense>
        ),
    },
    {
        path: "/LawyersCategoryFile/Edit/:id",
        element: (
            <Suspense fallback={<Loader />}>
                <EditLawyersCategoryFile />
            </Suspense>
        ),
    },
    {
        path: "/Lawyer",
        element: (
            <Suspense fallback={<Loader />}>
                <Lawyers />
            </Suspense>
        ),
    },
    {
        path: "/Lawyer/Create",
        element: (
            <Suspense fallback={<Loader />}>
                <CreateLawyer />
            </Suspense>
        ),
    },
    {
        path: "/Lawyer/Edit/:id",
        element: (
            <Suspense fallback={<Loader />}>
                <EditLawyer />
            </Suspense>
        ),
    },
    {
        path: "/ConsultationDuration",
        element: (
            <Suspense fallback={<Loader />}>
                <ConsultationDurations />
            </Suspense>
        ),
    },
    {
        path: "/ConsultationDuration/Create",
        element: (
            <Suspense fallback={<Loader />}>
                <CreateConsultationDuration />
            </Suspense>
        ),
    },
    {
        path: "/ConsultationDuration/Edit/:id",
        element: (
            <Suspense fallback={<Loader />}>
                <EditConsultationDuration />
            </Suspense>
        ),
    },
    {
        path: "/aboutUs",
        element: (
            <Suspense fallback={<Loader />}>
                <AboutUsManagmant />
            </Suspense>
        ),
    },
    {
        path: "/home",
        element: (
            <Suspense fallback={<Loader />}>
                <Home />
            </Suspense>
        ),
    },
    {
        path: "/adValidity",
        element: (
            <Suspense fallback={<Loader />}>
                <AdValidity />
            </Suspense>
        ),
    },

    { path: "/login", element: <Login /> },
    { path: "/createNewUser", element: <CreateNewUser /> },
    {
        path: "/usersList",
        element: (
            <Suspense fallback={<Loader />}>
                <UsersList />
            </Suspense>
        ),
    },
    {
        path: "/editUser",
        element: (
            <Suspense fallback={<Loader />}>
                <EditUser />
            </Suspense>
        ),
    },
    {
        path: "/userProfile/:id",
        element: (
            <Suspense fallback={<Loader />}>
                <UserProfile />
            </Suspense>
        ),
    },
    {
        path: "/ProfileDetail",
        element: (
            <Suspense fallback={<Loader />}>
                <ProfileDetail />
            </Suspense>
        ),
    },
    {
        path: "/suspension",
        element: (
            <Suspense fallback={<Loader />}>
                <Suspension />
            </Suspense>
        ),
    },
    {
        path: "/message",
        element: (
            <Suspense fallback={<Loader />}>
                <Message />
            </Suspense>
        ),
    },
    {
        path: "/slide",
        element: (
            <Suspense fallback={<Loader />}>
                <Slide />
            </Suspense>
        ),
    },
    {
        path: "/slide/new-slide",
        element: (
            <Suspense fallback={<Loader />}>
                <NewSlide />
            </Suspense>
        ),
    },
    {
        path: "/rules",
        element: (
            <Suspense fallback={<Loader />}>
                <Rules />
            </Suspense>
        ),
    },
    {
        path: "/category",
        element: (
            <Suspense fallback={<Loader />}>
                <Category />
            </Suspense>
        ),
    },

    {
        path: "/modals",
        element: (
            <Suspense fallback={<Loader />}>
                <Modals />
            </Suspense>
        ),
    },


    {
        path: "/teammateProfile",
        element: (
            <Suspense fallback={<Loader />}>
                <TeammateEditProfile />
            </Suspense>
        ),
    },
    // {
    //   path: "/teammateEdit/:id",
    //   element: (
    //     <Suspense fallback={<Loader />}>
    //       <TeammateEdit />
    //     </Suspense>
    //   ),
    // },
    {
        path: "/UserEdit/:id",
        element: (
            <Suspense fallback={<Loader />}>
                <UserEdit />
            </Suspense>
        ),
    },
    {
        path: "/EditSubscriberWallet/:id",
        element: (
            <Suspense fallback={<Loader />}>
                <EditSubscriberWallet />
            </Suspense>
        ),
    },
    {
        path: "/transactions",
        element: (
            <Suspense fallback={<Loader />}>
                <Transactions />
            </Suspense>
        ),
    },
    {
        path: "/createProduct",
        element: (
            <Suspense fallback={<Loader />}>
                <CreateProduct />
            </Suspense>
        ),
    },
    {
        path: "/estate",
        element: (
            <Suspense fallback={<Loader />}>
                <Estate />
            </Suspense>
        ),
    },
    {
        path: "/amlak",
        element: (
            <Suspense fallback={<Loader />}>
                <Amlak />
            </Suspense>
        ),
    },
    {
        path: "/CreateAd",
        element: (
            <Suspense fallback={<Loader />}>
                <CreateAd />
            </Suspense>
        ),
    },
    {
        path: "/UpdateAd",
        element: (
            <Suspense fallback={<Loader />}>
                <UpdateAd />
            </Suspense>
        ),
    },
    {
        path: "/state1",
        element: (
            <Suspense fallback={<Loader />}>
                <State1 />
            </Suspense>
        ),
    },
    {
        path: "/state2",
        element: (
            <Suspense fallback={<Loader />}>
                <State2 />
            </Suspense>
        ),
    },
    {
        path: "/state3",
        element: (
            <Suspense fallback={<Loader />}>
                <State3 />
            </Suspense>
        ),
    },
    {
        path: "/state4",
        element: (
            <Suspense fallback={<Loader />}>
                <State4 />
            </Suspense>
        ),
    },
    {
        path: "/state5",
        element: (
            <Suspense fallback={<Loader />}>
                <State5 />
            </Suspense>
        ),
    },
    {
        path: "/state6",
        element: (
            <Suspense fallback={<Loader />}>
                <State6 />
            </Suspense>
        ),
    },
    {
        path: "/state7",
        element: (
            <Suspense fallback={<Loader />}>
                <State7 />
            </Suspense>
        ),
    },
    {
        path: "/state8",
        element: (
            <Suspense fallback={<Loader />}>
                <State8 />
            </Suspense>
        ),
    },
    {
        path: "/state9",
        element: (
            <Suspense fallback={<Loader />}>
                <State9 />
            </Suspense>
        ),
    },
    {
        path: "/state10",
        element: (
            <Suspense fallback={<Loader />}>
                <State10 />
            </Suspense>
        ),
    },
    {
        path: "/state11",
        element: (
            <Suspense fallback={<Loader />}>
                <State11 />
            </Suspense>
        ),
    },
    {
        path: "/state12",
        element: (
            <Suspense fallback={<Loader />}>
                <State12 />
            </Suspense>
        ),
    },

    {
        path: "/productsList",
        element: (
            <Suspense fallback={<Loader />}>
                <ProductsList isIncomplete={false} />
            </Suspense>
        ),
    },
    {
        path: "/productsList/incomplete",
        element: (
            <Suspense fallback={<Loader />}>
                <ProductsList isIncomplete={true} />
            </Suspense>
        ),
    },
    {
        path: "/pageOne",
        element: (
            <Suspense fallback={<Loader />}>
                <PageOne />
            </Suspense>
        ),
    },
    {
        path: "/pageTwo",
        element: (
            <Suspense fallback={<Loader />}>
                <PageTwo />
            </Suspense>
        ),
    },
    {
        path: "/pageThree",
        element: (
            <Suspense fallback={<Loader />}>
                <PageThree />
            </Suspense>
        ),
    },
    {
        path: "/Reporteds",
        element: (
            <Suspense fallback={<Loader />}>
                <Reporteds />
            </Suspense>
        ),
    },
    {
        path: "/productDetails/:id",
        element: (
            <Suspense fallback={<Loader />}>
                <ProductDetails />
            </Suspense>
        ),
    },
    {
        path: "/support",
        element: (
            <Suspense fallback={<Loader />}>
                <Support />
            </Suspense>
        ),
    },
    {
        path: "/request",
        element: (
            <Suspense fallback={<Loader />}>
                <Request />
            </Suspense>
        ),
    },
    {
        path: "/confirmationRequest",
        element: (
            <Suspense fallback={<Loader />}>
                <ConfirmationRequest />
            </Suspense>
        ),
    },
    {
        path: "/confirmationRequestShop/:id",
        element: (
            <Suspense fallback={<Loader />}>
                <ConfirmationRequestShop />
            </Suspense>
        ),
    },
    {
        path: "/msgList",
        element: (
            <Suspense fallback={<Loader />}>
                <MsgList />
            </Suspense>
        ),
    },
    {
        path: "/report",
        element: (
            <Suspense fallback={<Loader />}>
                <Report />
            </Suspense>
        ),
    },
    {
        path: "/suggest",
        element: (
            <Suspense fallback={<Loader />}>
                <Suggest />
            </Suspense>
        ),
    },
    {
        path: "/automaticMsg",
        element: (
            <Suspense fallback={<Loader />}>
                <AutomaticMsg />
            </Suspense>
        ),
    },
    {
        path: "/sendGroupMsg",
        element: (
            <Suspense fallback={<Loader />}>
                <SendGroupMsg />
            </Suspense>
        ),
    },
    {
        path: "/msgSetting",
        element: (
            <Suspense fallback={<Loader />}>
                <MsgSetting />
            </Suspense>
        ),
    },
    {
        path: "/",
        element: (
            <Suspense fallback={<Loader />}>
                <MonitoringPage />
            </Suspense>
        ),
    },

    {
        path: "/discountAndScore",
        element: (
            <Suspense fallback={<Loader />}>
                <DiscountAndScore />
            </Suspense>
        ),
    },
    {
        path: "/priceManagement",
        element: (
            <Suspense fallback={<Loader />}>
                <PriceManagement />
            </Suspense>
        ),
    },
    {
        path: "/automation",
        element: (
            <Suspense fallback={<Loader />}>
                <Automation />
            </Suspense>
        ),
    },
    {
        path: "/chat/:id",
        element: (
            <Suspense fallback={<Loader />}>
                <Chat />
            </Suspense>
        ),
    },
    {
        path: "/CityProvinceManagement",
        element: (
            <Suspense fallback={<Loader />}>
                <CityProvinceManagement />
            </Suspense>
        ),
    },
    { path: "*", element: <NotFound /> },
];

export default router;
